<template>
  <li class="level-menu outside" @click="openlevelmenu" v-if="checkRole(['agent', 'admin'], ['beacon'])">
    <a class="nav-link" href="#">
      <feather type="list"></feather>
      <span>Beacon</span>
    </a>
    <ul style="z-index: 20;text-align: left; width: auto;" class="header-level-menu menu-to-be-close"
      :class="{ 'd-block': openLevelmenu }">
      <li @click="$router.push('/beacon/case-management')" class='clickMenu'
        v-if="checkRole(['admin', 'agent'], ['beacon'])">
        <router-link to="/beacon/case-management" class="sidebar-link sidebar-title" router-link-exact-active>
          <span>Case Management</span>
        </router-link>
      </li>

      <li v-if="checkRole(['admin'], ['beacon'])" style=" border-top: 1px solid #ccc;">
        <span>Admin Management</span>
      </li>
      <li @click="$router.push('/beacon/company')" class='clickMenu' v-if="checkRole(['admin'], ['beacon'])">
        <router-link to="/beacon/company" class="sidebar-link sidebar-title" router-link-exact-active>
          <feather type="corner-down-right"></feather>
          <span>Company</span>
        </router-link>
      </li>
      <li @click="$router.push('/beacon/member')" class='clickMenu' v-if="checkRole(['admin'], ['beacon'])">
        <router-link to="/beacon/member" class="sidebar-link sidebar-title" router-link-exact-active>
          <feather type="corner-down-right"></feather>
          <span>Member</span>
        </router-link>
      </li>
      <li @click="$router.push('/beacon/group')" class='clickMenu' v-if="checkRole(['admin'], ['beacon'])">
        <router-link to="/beacon/group" class="sidebar-link sidebar-title" router-link-exact-active>
          <feather type="corner-down-right"></feather>
          <span>Group</span>
        </router-link>
      </li>
      <li @click="$router.push('/beacon/application')" class='clickMenu' v-if="checkRole(['admin'], ['beacon'])">
        <router-link to="/beacon/application" class="sidebar-link sidebar-title" router-link-exact-active>
          <feather type="corner-down-right"></feather>
          <span>Application</span>
        </router-link>
      </li>
      <li @click="$router.push('/beacon/category')" class='clickMenu' v-if="checkRole(['admin'], ['beacon'])">
        <router-link to="/beacon/category" class="sidebar-link sidebar-title" router-link-exact-active>
          <feather type="corner-down-right"></feather>
          <span>Category</span>
        </router-link>
      </li>
      <li @click="$router.push('/beacon/annoucement')" class='clickMenu' v-if="checkRole(['admin'], ['beacon'])">
        <router-link to="/beacon/annoucement" class="sidebar-link sidebar-title" router-link-exact-active>
          <feather type="corner-down-right"></feather>
          <span>Annoucement</span>
        </router-link>
      </li>
      <li @click="$router.push('/beacon/symptom')" class='clickMenu' v-if="checkRole(['admin'], ['beacon'])">
        <router-link to="/beacon/symptom" class="sidebar-link sidebar-title" router-link-exact-active>
          <feather type="corner-down-right"></feather>
          <span>Symptom</span>
        </router-link>
      </li>
      <li @click="$router.push('/beacon/rule')" class='clickMenu' v-if="checkRole(['admin'], ['beacon'])">
        <router-link to="/beacon/rule" class="sidebar-link sidebar-title" router-link-exact-active>
          <feather type="corner-down-right"></feather>
          <span>Rule</span>
        </router-link>
      </li>


      <li v-if="checkRole(['admin'], ['beacon'])" style=" border-top: 1px solid #ccc;">
        <span>Report</span>
      </li>
      <li @click="$router.push('/beacon/report/case')" class='clickMenu' v-if="checkRole(['admin'], ['beacon'])">
        <router-link to="/beacon/report/case" class="sidebar-link sidebar-title" router-link-exact-active>
          <feather type="corner-down-right"></feather>
          <span>Case</span>
        </router-link>
      </li>
      <li @click="$router.push('/beacon/report/sms')" class='clickMenu' v-if="checkRole(['admin'], ['beacon'])">
        <router-link to="/beacon/report/sms" class="sidebar-link sidebar-title" router-link-exact-active>
          <feather type="corner-down-right"></feather>
          <span>Sms</span>
        </router-link>
      </li>

    </ul>
  </li>
</template>

<script>
export default {
  name: 'LevelMenu',
  data() {
    return {
      openLevelmenu: false,
    };
  },
  methods: {
    openlevelmenu() {
      this.openLevelmenu = !this.openLevelmenu;
      if (this.openLevelmenu) {
        this.$emit('closeMenu')
      }
    },
    checkRole(role, module) {

      if (role == undefined && module == undefined) {
        return false
      }
      let status_ccp = false
      let status_beacon = false
      let userinfo = localStorage.getItem("userinfo")
      userinfo = JSON.parse(userinfo)
      for (let i = 0; i < module.length; i++) {
        if (module[i] == "beacon") {
          if (userinfo.role_beacon == undefined) {
            status_beacon = false
          }
          status_beacon = role.includes(userinfo.role_beacon);
        }
        else if (module[i] == "ccp") {
          if (userinfo.role_ccp == undefined) {
            status_ccp = false
          }
          status_ccp = role.includes(userinfo.role_ccp);
        }
      }
      return (status_ccp || status_beacon)
    },
  },
};
</script>

<style scoped>
.clickMenu {
  cursor: pointer;
}
</style>